import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import HomePage from './HomePage';
import { fetchPublicCmsConfig } from '../utils/cmsConfigCache';

const DynamicPage = () => {
  const { slug, '*': rest } = useParams();
  const routeSlug = slug || rest;
  const [pageData, setPageData] = useState(null);
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    loadPage();
  }, [routeSlug]);

  const loadPage = async () => {
    try {
      setLoading(true);
      setNotFound(false);
      const cfg = await fetchPublicCmsConfig();
      setConfig(cfg);

      // Find the page by slug
      const pages = cfg.pages || [];
      const page = pages.find(p => (p.slug === `/${routeSlug}` || p.slug === routeSlug) && p.published !== false && p.visible !== false && p.status !== 'draft');

      if (!page) {
        setNotFound(true);
        return;
      }

      setPageData(page);
    } catch (error) {
      console.error('Error loading page:', error);
      setNotFound(true);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (notFound) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <h1 data-testid="not-found-title" className="text-6xl font-bold text-slate-300 mb-4">404</h1>
          <p data-testid="not-found-message" className="text-xl text-slate-600 mb-6">Stránka nebyla nalezena</p>
          <Link data-testid="not-found-home-link" to="/" className="text-blue-600 hover:text-blue-700 font-medium">
            Zpět na hlavní stránku
          </Link>
        </div>
      </div>
    );
  }

  // Render the page using HomePage component with page-specific blocks
  // Pass the page's blocks instead of the main config blocks
  return (
    <HomePage 
      overrideBlocks={pageData?.blocks} 
      pageTitle={pageData?.title}
      sharedHeader={pageData?.sharedHeader !== false}
      sharedFooter={pageData?.sharedFooter !== false}
      pageNavigation={pageData?.navigation_mode === 'custom' ? (pageData?.custom_navigation || null) : null}
      pageFooter={pageData?.footer_mode === 'custom' ? (pageData?.custom_footer || null) : null}
    />
  );
};

export default DynamicPage;
